import { useEffect, useRef } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import styled from "styled-components";

const FlashDesign = styled.div`
  .fade-appear {
    opacity: 0.1;
    z-index: 1;
  }
  .fade-appear.fade-appear-active {
    opacity: 1;
    transition: opacity 300ms ease-in;
  }
  .fade-enter {
    opacity: 0.1;
    z-index: 1;
  }
  .fade-enter.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-in;
  }
  .fade-exit {
    opacity: 0.1;
  }
  .fade-exit.fade-exit-active {
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    opacity: 0;
    transition: opacity 300ms ease-out;
  }
`;

type Props = {
  children: React.ReactNode;
};
export const TransionFlash: React.FC<Props> = ({ children }) => {
  const nodeRef = useRef(null);

  useEffect(() => {
    const returnTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
    returnTop();
  }, []);

  return (
    <FlashDesign>
      <TransitionGroup>
        <CSSTransition
          nodeRef={nodeRef}
          appear
          in
          key="Hello"
          classNames="fade"
          timeout={300}
          unmountOnExit
        >
          <div ref={nodeRef}>{children}</div>
        </CSSTransition>
      </TransitionGroup>
    </FlashDesign>
  );
};
